import {useEffect} from 'react';

import useLandscapeOrientation from '~/customHooks/useLandscapeOrientation';
import useModalById from '~/customHooks/useModalById';
import {MODAL_ORIENTATION_CHANGE} from '~/rootStore/modals/modalsIds';

import ModalBaseContent from '../ModalBaseContent';
import ModalBase from '../ModalBase';
import image from './img/switch-orientation.svg';

const ModalOrientationChange: React.FC = () => {
  const isHorizontalOrientation = useLandscapeOrientation();
  const {
    isOpen,
    open: openOrientationChangeModal,
    close: closeOrientationChangeModal,
  } = useModalById(MODAL_ORIENTATION_CHANGE);

  useEffect(() => {
    if (isHorizontalOrientation) {
      openOrientationChangeModal();
    } else {
      closeOrientationChangeModal();
    }
  }, [isHorizontalOrientation, openOrientationChangeModal, closeOrientationChangeModal]);

  return (
    <ModalBase open={isOpen} onClose={closeOrientationChangeModal}>
      <ModalBaseContent
        p={2}
        image={image}
        title="Switch to portrait mode"
        description="Sorry, for better user experience switch to portrait mode"
        actionButtonText="OK"
        onClickActionButton={closeOrientationChangeModal}
      />
    </ModalBase>
  );
};

export default ModalOrientationChange;
